<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body row-set-line">
  
				  <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
					<div class="btn-group enrollment-list-btn-info" role="group">
					  <button id="status-btns" type="button" *ngFor="let status of statusList" class="btn"
						[ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
						(click)="activeJobTab(status?.name)">{{status?.displayname}}</button>
					</div>
				  </div>
				  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
					<div class="row-flex">
					  <!-- <div class="col-flex-2 mb-1">
						<div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
						  <button type="button" class="btn btn-outline-primary btn2">{{project_type}}</button>
						  <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
							aria-haspopup="true" aria-expanded="false">
							<span class="sr-only">Toggle Dropdown</span>
						  </button>
						  <div ngbDropdownMenu class="dropdown-menu" role="menu">
							<button class="dropdown-item" *ngFor="let item of dropdownList"
							  (click)="getProjectTypeId(item?.id,item?.name)">{{item?.name}}</button>
						  </div>
						</div>
					  </div> -->
					  <div class="col-flex-2 mb-1">
						<div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
						  <button type="button" class="btn btn-outline-primary btn1">{{selectedTechnology}}</button>
						  <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
							aria-haspopup="true" aria-expanded="false">
							<span class="sr-only">Toggle Dropdown</span>
						  </button>
						  <div ngbDropdownMenu class="dropdown-menu" role="menu">
							<button class="dropdown-item" *ngFor="let item of technology_List"
							  (click)="getTechnologyId(item?._id,item?.displayname)">{{item?.displayname}}</button>
						  </div>
						</div>
					  </div>
					  <div class="col-flex-2 mb-1 position-relative">
						<input id="ngx-filter-ref"
						  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
						  type="text" placeholder="Search" #name />
						<button class="btn search-btn glow position-absolute" (click)="getJobFilter(name?.value)">
						  <i class="ft-search text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button class="btn btn-primary btn-block users-list-clear glow mb-0 reset-btn" (click)="resetFilter()">
						  Reset
						  <i class="ft-filter text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1"
						*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
						<button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
						  routerLink="/jobs/add" placement="top" ngbTooltip="Add New">
						  +
						</button>
					  </div>
  
					</div>
				  </div>
				  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
					<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
					  [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
					  [count]="page?.totalPages" [offset]="page?.pageNumber"
					  (page)="pageChangeData($event)"></ngx-datatable>
				  </div>
				  <div class="col-12">
					<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Jobs Guideline</button>
					</div>
				</div>
			  </fieldset>
			
			  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
				[footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
				[columns]="columns" [externalPaging]="true" [count]="page?.totalPages" [offset]="page.pageNumber"
				(page)="pageChangeData($event)">
				<ngx-datatable-column name="Project Name" prop="name" [width]="300">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="d-flex align-items-center">
					  <div class="cell-line-height cursor-pointer">
						<p class="font-medium-1 line-height-1 mb-0" [ngClass]="{'bg-class-color badge badge-pill': row?.workon[0]?.displayname ==='Product'?row?.workon[0]?.displayname ==='Product':'' }" placement="right" [ngbTooltip]="row?.notes" (click)="openNotesModal(notesModal,row)">
						  {{ row?.name }}
						</p>
					  </div>
					</div>
				  </ng-template>
				</ngx-datatable-column>
		  
				<ngx-datatable-column name="Alert" prop="isalert" [width]="50">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<p placement="right" [ngbTooltip]="row?.alert_notes" [matMenuTriggerFor]="job_alert">
					  <span [ngClass]="{'bg-light-danger badge badge-pill':row?.isalert == 'yes'}"
						*ngIf="row?.isalert == 'yes'">{{row?.isalert | titlecase }}</span>
					  <span [ngClass]="{'bg-light-success badge badge-pill':row?.isalert == 'no'}"
						*ngIf="row?.isalert == 'no'">{{row?.isalert | titlecase }}</span>
					</p>
					<mat-menu #job_alert="matMenu">
					  <div *ngFor="let item of alert_list">
						<button mat-menu-item *ngIf="item?.id !== row?.isalert" (click)="updateJobAlert(row?._id,item?.id)">
						  <span>
							<span [ngClass]="{'bg-light-danger badge badge-pill':item?.name == 'Yes'}" placement="top"
							  *ngIf="item?.name == 'Yes'">{{item?.name}}</span>
							<span [ngClass]="{'bg-light-success badge badge-pill':item?.name == 'No'}" placement="top"
							  *ngIf="item?.name == 'No'">{{item?.name}}</span>
						  </span>
						</button>
					  </div>
					</mat-menu>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Priority" prop="priority" [width]="70">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<p placement="right" [ngbTooltip]="row?.admin_notes" [matMenuTriggerFor]="job_priority">
					  <span *ngIf="row?.priority?.displayname == 'Urgent'"
						[ngClass]="{'bg-light-warning badge badge-pill':row?.priority?.displayname == 'Urgent'}">
						{{row?.priority?.displayname}}
					  </span>
					  <span *ngIf="row?.priority?.displayname == 'High'"
						[ngClass]="{'bg-light-danger badge badge-pill':row?.priority?.displayname == 'High'}">
						{{row?.priority?.displayname}}
					  </span>
					  <span *ngIf="row?.priority?.displayname == 'Normal'"
						[ngClass]="{'bg-light-success badge badge-pill':row?.priority?.displayname == 'Normal'}">
						{{row?.priority?.displayname}}
					  </span>
					</p>
					<mat-menu #job_priority="matMenu">
  
					  <div>
						<div *ngFor="let priority of priorityList">
						  <button mat-menu-item *ngIf="priority?.name !== row?.priority?.name"
							(click)="updateJobPriority(row?._id,priority?._id)">
							<span>
							  <span [ngClass]="{'bg-light-warning badge badge-pill':priority?.displayname == 'Urgent'}"
								placement="top" *ngIf="priority?.displayname == 'Urgent'">{{priority?.displayname}}</span>
							  <span [ngClass]="{'bg-light-danger badge badge-pill':priority?.displayname == 'High'}"
								placement="top" *ngIf="priority?.displayname == 'High'">{{priority?.displayname}}</span>
							  <span [ngClass]="{'bg-light-success badge badge-pill':priority?.displayname == 'Normal'}"
								placement="top" *ngIf="priority?.displayname == 'Normal'">{{priority?.displayname}}</span>
							</span>
						  </button>
						</div>
					  </div>
					</mat-menu>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="References" prop="references" [width]="180">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<span *ngIf="row?.references">
					  <div class="badge badge-pill text-capitalize bg-light-primary mr-1 mb-1"
						*ngFor="let item of row.references; last as isLast">
						<a [href]="item?.links" target="_blank">
						  {{item?.name}}
						</a>
						<!-- <span *ngIf="item.length>1 && !isLast">,</span> -->
					  </div>
					</span>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Hunting" prop="hunting_by" [width]="140">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<p *ngFor="let item of row?.hunting_by; last as isLast">
					  <span placement="right"
						[ngbTooltip]="'source : '+row?.source[0]?.displayname +', channel : '+row?.channel?.name">
						{{item?.name}}
					  </span>
					  <span *ngIf="item?.name?.length>1 && !isLast">,</span>
					</p>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Farming" prop="farming_by" [width]="140">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<p *ngFor="let item of row?.farming_by; last as isLast">
					  <span placement="bottom" [ngbTooltip]="row?.technology[0]?.displayname">
						{{item?.name}}
					  </span>
					  <span *ngIf="item?.name?.length>1 && !isLast">,</span>
					</p>
				  </ng-template>
				</ngx-datatable-column>
			 
  
				<ngx-datatable-column name="Actions" [width]="80"
				  *ngIf=" user_role?.roles =='admin' || user_role?.roles =='employee' || user_role?.roles =='extractor'">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<!-- <i class="ft-edit text-primary cursor-pointer mr-2" (click)="editContact(row)"></i>
					<i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
					  (click)="Delete(row._id)"></i> -->
					<i mat-button [matMenuTriggerFor]="menu1" *ngIf="activeTab !=='pending'"
					  class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
					<i mat-button *ngIf="activeTab !=='pending'" class="ft-credit-card text-primary cursor-pointer mr-2"
					  placement="bottom" ngbTooltip="Add Payment" (click)="openModal(myModal,row?._id)"></i>
					<i class="ft-codepen cursor-pointer text-primary " (click)="updateWorkonJob(row?._id)"></i><br>
					<i class="ft-settings cursor-pointer text-primary" placement="left" ngbTooltip="Attach Client"  (click)="openModal3(attachClientModal,row._id)"></i>
					<button *ngIf="activeTab =='pending'" class="btn btn-primary btn-block users-list-clear glow mb-0"
					  (click)="editJob(row)">Process</button>
  
					<mat-menu #menu1="matMenu">
					  <button mat-menu-item (click)="editJob(row)">Edit</button>
					  <button mat-menu-item [routerLink]="['/jobs/view', row?._id]">Manage</button>
					  <div>
						<div *ngFor="let status of statusList | slice:0">
						  <button mat-menu-item
							*ngIf="status?._id !== row?.status[0]?._id && status?.name !== 'pending' && status?.name !=='archive' && activeTab !=='closed' && activeTab !=='archive'"
							(click)="updateJobStatus(row?._id,status)">Move to {{status?.displayname}}</button>
							<button mat-menu-item
							*ngIf="status?.name =='archive' && activeTab =='closed'"
							(click)="updateJobStatus(row?._id,status)">Move to {{status?.displayname}}</button>
						</div>
					  </div>
					  <button mat-menu-item [routerLink]="['/project/project-edit', row?._id]">Audit</button>
					  <button mat-menu-item (click)="openModal2(myModal2,row)">Attach Lead</button>
					  <button mat-menu-item (click)="Delete(row?._id)">Delete</button>
					  <button mat-menu-item (click)="goToSprint(row?._id)">Product Sprint</button>

					</mat-menu>
				  </ng-template>
				</ngx-datatable-column>
			  </ngx-datatable>
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  
  <!----- Job Payment Popup ----------->
  <div>
	<ng-template #myModal let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">Transaction</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<div class="top-content">
		  <table *ngIf="payment_data">
			<tbody>
			  <tr>
				<th>Net Amount :</th>
				<td>
				  <span *ngIf="payment_data[0]?.job_id?.projectbudget">{{payment_data[0]?.job_id?.projectbudget}}</span>
				</td>
			  </tr>
			  <tr>
				<th>Paid Amount :</th>
				<td>
				  <span class="bg-light-success"
					*ngIf="payment_data[0]?.total_paid">{{payment_data[0]?.total_paid}}</span>
				</td>
			  </tr>
			  <tr>
				<th>Pending Amount :</th>
				<td>
				  <span class="bg-light-danger"
					*ngIf="payment_data[0]?.pendingAmount">{{payment_data[0]?.pendingAmount}}</span>
				</td>
			  </tr>
			  <tr>
				<th>Mode :</th>
				<td>{{payment_data[0]?.mode?.displayname}}</td>
			  </tr>
			  <tr *ngIf="enrolmentData?.net_fees !== enrolmentData?.paid_fee">
				<th>Next Payment Date :</th>
				<td>{{enrolmentData?.next_payment_date | date :'mediumDate'}}</td>
			  </tr>
			</tbody>
  
		  </table>
		</div>
		<hr>
		<form>
		  <div class="form-group">
			<label>Amount</label>
			<input type="text" class="form-control" [(ngModel)]="payment_model.paid_amount"
			  [ngModelOptions]="{standalone: true}">
		  </div>
		  <div class="form-group">
			<label>Payment Mode</label>
			<ng-select [items]="paymentMode" bindLabel="displayname" bindValue="_id" placeholder="Select Payment Mode"
			  [(ngModel)]="selectedPaymentMode" [ngModelOptions]="{ standalone: true }"
			  (change)="getPaymentModeId($event)">
			</ng-select>
		  </div>
		  <div class="form-group">
			<label>Payment Status</label>
			<ng-select [items]="pamentStatusList" bindLabel="label" bindValue="name" placeholder="Select Status"
			  [(ngModel)]="selectedPaymentStatus" [ngModelOptions]="{ standalone: true }">
			</ng-select>
		  </div>
		  <div class="form-group">
			<label>Payment Notes</label>
			<input type="text" class="form-control" [(ngModel)]="payment_model.payment_notes"
			  [ngModelOptions]="{standalone: true}">
		  </div>
		  <div class="form-group">
			<label>Next Payment Date</label>
			<input type="date" class="form-control" [(ngModel)]="payment_model.next_paymentdate"
			  [ngModelOptions]="{standalone: true}">
		  </div>
		</form>
  
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="payment()">Submit</button>
	  </div>
	</ng-template>
  </div>
  <!----------- Attach Lead Popup --------------------->
  <div>
	<ng-template #myModal2 let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">Lead Detail</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<table id="table" *ngIf="lead_data">
		  <tbody>
			<tr>
			  <th>Lead Title :</th>
			  <td>
				<span *ngIf="lead_data?.title">{{lead_data?.title}}</span>
			  </td>
			</tr>
			<tr>
			  <th>Lead Status :</th>
			  <td>
				<span class="badge badge-pill text-capitalize bg-light-danger mr-1"
				  *ngIf="lead_data?.lead_status?.displayname">{{lead_data?.lead_status?.displayname}}</span>
			  </td>
			</tr>
			<tr>
			  <th>Lead Stage :</th>
			  <td>
				<span class="badge badge-pill text-capitalize bg-light-primary mr-1"
				  *ngIf="lead_data?.lead_stage?.displayname">{{lead_data?.lead_stage?.displayname}}</span>
			  </td>
			</tr>
			<tr>
			  <th>Source :</th>
			  <td>
				<span *ngIf="lead_data?.source?.displayname">{{lead_data?.source?.displayname}}</span>
			  </td>
			</tr>
			<tr>
			  <th>Next Action :</th>
			  <td>
				<span *ngIf="lead_data?.next_action?.displayname">{{lead_data?.next_action?.displayname}}</span>
			  </td>
			</tr>
			<tr>
			  <th>Type :</th>
			  <td>
				<span *ngIf="lead_data?.type?.displayname">{{lead_data?.type?.displayname}}</span>
			  </td>
			</tr>
			<tr>
			  <th>Notes :</th>
			  <td [innerText]="lead_data?.notes">
			  </td>
			</tr>
			<tr>
			  <th>Admin Notes :</th>
			  <td [innerText]="lead_data?.admin_notes">
			  </td>
			</tr>
		  </tbody>
		</table>
		<div *ngIf="!lead_data">
		  <small style="color: red;  margin-left: 35%;">Data Not Found!</small>
		</div>
	  </div>
	  <!-- <div class="modal-footer">
			  <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			  <button type="button" class="btn btn-primary" (click)="payment()">Submit</button>
			</div> -->
	</ng-template>
  </div>

<!----------- Alert Notes Popup --------------------->
<div>
	<ng-template #notesModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">{{lead_data?.name}}</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<table id="table" *ngIf="lead_data">
				<div>
					<p class="badge bg-light-info mr-4" placement="top" ngbTooltip="Channel">{{lead_data?.channel?.name}}</p>
				
					<p *ngFor="let item of lead_data.technology" class="badge bg-light-secondary" placement="top"
						ngbTooltip="Technology">{{item?.displayname}}</p>
				</div>
				<tr>
					<td> 
						<span><b>Alert Notes :</b></span> <span class="mx-2"><i class="ft-edit cursor-pointer" (click)="isEditAlertNotes=!isEditAlertNotes"></i></span> <span class="content" [innerHtml]="lead_data?.alert_notes | safeHtml"></span>
						
					</td>
				</tr>
				<div *ngIf="isEditAlertNotes">
					<!-- <textarea name="notes" id="notes" class="form-control" [(ngModel)]="lead_data.alert_notes" rows="5"></textarea> -->
					<quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="alert_notes($event)" [(ngModel)]="lead_data.alert_notes"
						[ngModelOptions]="{ standalone: true }">
					</quill-editor>
					<button class="btn btn-primary btn-sm my-1" (click)="updateNotes('alert notes')">Update</button>
				</div>
				<tr>
					<td> 
						<span><b>Process Notes :</b></span><span class="mx-2"><i class="ft-edit cursor-pointer" (click)="isEditNotes=!isEditNotes"></i></span>
						 <span class="content" [innerHtml]="lead_data?.notes | safeHtml"></span>
					</td>
				</tr>
				<div *ngIf="isEditNotes">
					<!-- <textarea name="notes" id="notes" class="form-control" [(ngModel)]="lead_data.notes" rows="5"></textarea> -->
					<quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="notes($event)" [(ngModel)]="lead_data.notes" [ngModelOptions]="{ standalone: true }">
					</quill-editor>
					<button class="btn btn-primary btn-sm my-1" (click)="updateNotes('notes')">Update</button>
				</div>
				<tr>
					<td> 
						<span><b>Credentials & Admin Notes :</b></span><span class="mx-2"><i class="ft-edit cursor-pointer" (click)="isEditAdminNotes=!isEditAdminNotes"></i></span>
						<span class="content" [innerHtml]="lead_data?.admin_notes | safeHtml"></span>
						
					</td>
				</tr>
				<div *ngIf="isEditAdminNotes">
					<!-- <textarea name="notes" id="notes" class="form-control" [(ngModel)]="lead_data.admin_notes" rows="5"></textarea> -->
					<quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="admin_notes($event)" [(ngModel)]="lead_data.admin_notes"
						[ngModelOptions]="{ standalone: true }">
					</quill-editor>
					<button class="btn btn-primary btn-sm my-1" (click)="updateNotes('admin notes')">Update</button>
				</div>
			</table>
		</div>
	</ng-template>
</div>
<!-- Attach Client -->

<div>
	<ng-template #attachClientModal>
	  <div class="modal-header">
		<h4 class="modal-title">Attach Client</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<div class="form-group">
		  <label>Client</label>
		  <ng-select
					[items]="clients_list"
					bindLabel="name"
					bindValue="_id"
					[closeOnSelect]="false"
					placeholder="Select Client"
					[(ngModel)]="selected_client"
					[ngModelOptions]="{ standalone: true }"
					(change)="getClientId($event)"
					[appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true"
				  >
				  </ng-select>
		</div>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="updateClient()">Submit</button>
	  </div>
	</ng-template>
  </div>
  
   <!-- ------- -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>
  
  